import { IEditRolePayload, IRoleCreate, IRoleListSearch } from "../../../../types/master/roleInterface";
import api from "../../../../lib/api";

export const createRoleApi = async (data: IRoleCreate) => {
  return await api.post(`/role`, data);
};

export const getRoleListApi = async (data: IRoleListSearch) => {
  return await api.get(`role/${data.page}/${data.pageLimit}`, {
    params: {
      search: data.search ?? "",
      departmentId: data.departmentId
    }
  });
};

export const getRoleDataByIdApi = async (id: number) => {
  return await api.get(`/role/${id}`);
};

export const editRoleDataByIdApi = async (payload: IEditRolePayload) => {
  return await api.put(`/role/${payload.id}`, payload.data);
};
